export const tooltipMap = {
  advertiser_cost: {
    title: "Advertiser Cost",
    body: "Total amount spent by advertiser on DSP ",
  },
  media_cost: {
    title: "Media Cost",
    body: "Actual amount spent on media",
  },
  savings: {
    title: "Savings",
    body: "TeCreo efficiency ",
  },
  cpm: {
    title: "eCPM",
    body: "eCPM",
  },
  impressions: {
    title: "Impressions",
    body: "Total Impression onn DSP",
  },
};
